package com.patronat.top.features.venues.domain.usecase.command

import com.patronat.top.dto.VenueAiImportRequest

data class ImportVenueWithAiCommand(
    val request: VenueAiImportRequest
)
